import { footerBannerData } from "@/data/content";
import Heading from "@/shared/Heading/Heading";

const FooterBanner = () => {
  return (
    <div className="rounded-2xl bg-[url('/bgProducts.jpg')] bg-cover bg-center bg-no-repeat py-16 text-white">
      <Heading className="mb-0" isMain isCenter>
        {footerBannerData.heading}
      </Heading>
      <div className="mt-10 flex items-center justify-center" />
    </div>
  );
};

export default FooterBanner;
